import React, {useEffect, useState} from 'react';
import UserManager, {useUserData} from "../../../managers/userManager/userManager";
import CartManager from "../../../managers/cartManager/cartManager";
import Button from "@mui/material/Button";
import LockerCard from "./LockerCard";
import {Trans, useTranslation} from "react-i18next";

function EasyBoxHandler(props) {
    const userData = useUserData();
    const [easyBox, setEasyBox] = useState(CartManager.getEasyBox());
    const {i18n} = useTranslation();

    useEffect(() => {
        if (easyBox) {
            CartManager.submitEasyBox(easyBox);
            CartManager.submitAddress('easyBox');
        }
    }, [easyBox]);

    useEffect(() => {
        if (!i18n) {
            return;
        }

        const pluginInstance = window.LockerPlugin.getInstance();
        i18n.on("languageChanged", () => {
            pluginInstance.reinitializePlugin({
                langCode: i18n.language
            });
        });
    }, [i18n])

    const openEasyBox = () => {
        const clientId = "2fc08df6-a2fd-4da4-9c1f-d93eeb82c2d6";
        const countryCode = "RO";
        const langCode = i18n.language;
        const city = userData?.cart?.userData?.city;
        const county = userData?.cart?.userData?.county;
        const favLockerId = userData?.favLocker?.lockerId;
        const favType = userData?.favLocker?.type;
        const theme = "light";
        const apiUsername = "diwiprintAPI";
        const filters =
            [{"showLockers": true}, {"showPudos": true}];

        window.LockerPlugin.init({
            clientId: clientId,
            countryCode: countryCode,
            langCode: langCode,
            favLockerId: favLockerId,
            favType: favType,
            city: city,
            county: county,
            theme: theme,
            apiUsername: apiUsername,
            filters: filters
        });
        const newPluginInstance = window.LockerPlugin.getInstance();
        newPluginInstance.subscribe(onSelect);
        newPluginInstance.subscribeToFavouriteLocker(onFavoriteSelect);
        newPluginInstance.open();
    }

    const onSelect = (msg) => {
        setEasyBox(msg);
        window.LockerPlugin.getInstance().close();
    }

    const onFavoriteSelect = (msg) => {
        UserManager.savePreferredEasyBox(msg);
    }

    return (
        <div className="easyboxhandler">
            <Button onClick={openEasyBox}><Trans i18nKey={'easyBox.selectEasyBox'}/></Button>
            {easyBox && <LockerCard locker={easyBox}/>}
        </div>
    );
}

export default EasyBoxHandler;
